const Standards = {

    "학업/능력" : [
        {
            from : "다른 사람들에게 뭐든 잘한다는 평가를 받고 싶다.",
            to : ["'무엇이든' 잘해야 한다는 목표는 내가 해낸 것보다 해내지 못한 것이 더 많아 보이게 합니다. 구체적인 목표를 정하여 한번에 하나씩 해내는 데 초점을 맞춰보는 것은 어떨까요?", "내가 중요하게 여기는 ~부터 해내도록 해보자."],
        },
        {
            from : "무리를 해서라도 반드시 좋은 결과를 내야한다.",
            to : ["좋은 결과를 내려 무리하다보면 완수하지 못했을 때의 자책이 반드시 찾아오게 됩니다. 한번에 무리하기보다 마라톤처럼 꾸준히 할 때 좋은 결과가 나올 확률이 높아지지 않을까요?", "좋은 결과를 내기 위해 꾸준히 과정에 집중하자."],
        },
        {
            from : "반드시 대회에서 수상해야만 한다.",
            to : ["대회에서 수상한다는 것은 좋은 성과도 물론 중요하지만, 완전히 통제할 수 없는 요인이 작용하기도 합니다. 그러므로 수상하지 못한다 하더라도 대회를 준비하며 쌓인 실력이 사라지는 것이 아니니 포기하지 않고 계속해서 시도하는 마음이 중요합니다.", "대회에서 수상할 정도의 실력을 쌓아보자."],
        },
        {
            from : "이왕 일을 시작할거라면, 최고의 결과를 내고싶다.",
            to : ["최고의 결과를 내고 싶다는 기준은 달성하지 못할 때의 두려움을 크게 만들어 시작을 망설이게 합니다. 누구라도 한번에 최고의 결과를 얻기는 어렵습니다.", "일단 시작해서 꾸준히 하다보면 좋은 결과를 낼 수 있다. 완성을 걱정하기 이전에 일단 시작하자."],
        }, 
        {
            from : "내가 하는 일이 사회적으로 가치가 있어야 한다.",
            to : ["내가 하는 일의 만족감이나 성취감의 기준이 사회 혹은 타인일 때 달성하기 어렵습니다. 그러므로 나의 업무에서 가치는 자신의 기준으로 설정해야 합니다.", "나는 환경보호에 관심이 있으니 친환경적인 일을 하는 회사에서 일하고 싶다."],
        },
        {
            from : "과제물을 제출할 때는 내용뿐만 아니라 항상 남들보다 창의적인 결과물을 내어야 한다.",
            to : ["남들과 비교하며 뛰어나게 하려는 압박감은 오히려 과제에 방해가 될 수 있다.", "우선 필수적인 과제의 내용을 1차 목표로 잡고, 이후 창의력을 한 스푼을 넣어보자."],
        },
        {
            from : "모든 일은 완벽한 결과를 내어야 한다.",
            to : ["모든 일을 완벽하게 해낸다는 건 도달하기 힘든 비현실적이고 모호한 주관적인 기준입니다.","완벽한 결과 보다 과정에 집중하고 성장과 성취감에 집중하도록 하자."],
        },
        {
            from : "남들보다는 잘해야 한다.",
            to : ["매우 비현실적이도 추상적인 기준입니다. 특히 이러한 비교에서 오는 기준은 늘 잘하는 최고와 나를 비교하기 때문에 상실감을 항상 느낄 수 밖에 없습니다.", "하루하루 어제의 나보다 조금씩이라도 성장하고 발전하는 사람이 되고 싶다."],
        },
    ],
    "외모/건강" : [
        {
            from : "남들이 보기에 늘 날씬하고 이쁘게 유지해야 한다.",
            to : ["남들의 시선이 아닌 나 자신의 체형에 맞춰 현실적인 기준을 세워보자.", "나는 키가 160cm이니 53kg정도의 체중으로 건강하게 유지하겠다. 또는 건강을 해치지 않는 수준에서 원하는 몸무게를 범주화해 정해보자."],
        },
        {
            from : "살이 찌면 안된다.",
            to : ["완벽주의자는 '전부 아니면 전무의 논리'라고 불리는 흑백 논리의 오류를 범하기 쉽습니다. 자신의 기준을 정해두고 1g 이라도 늘어나게 되면 '실패'로 여겨 자책하곤 합니다. 그러므로 자신이 유지할 몸무게를 정해놓더라도 변동이 있을 수 있다는 사실을 유념해야 합니다.", "체중을 00kg정도로 유지하고 싶다."],
        },
        {
            from : "피곤한 날에도 내 할일을 거뜬하게 할 수 있는 체력이 있어야 한다.",
            to : ["늘 체력이 완벽히 유지되는 것은 이론적으로 가능하지만, 현실적으로는 불가능합니다. 때로는 피곤하지만 할 일을 어느정도 안정적으로 해낼 수 있을 정도면 충분합니다.", "피곤한 날도 있을 수 있다. 하지만 피곤한 날이 줄어들 수 있게 꾸준히 체력관리는 해야겠다."],
        },
        {
            from : "옷이나 헤어스타일이 유행에 뒤쳐져선 안된다.",
            to : ["나의 스타일보다는 유행이나 다른 사람들의 시선을 기준으로 자신을 평가하고 뒤따르면 늘 남들과 비교하며 불안할 수 밖에 없습니다.", "유행하는 헤어, 옷 스타일은 금방 지나가기 마련이니 내가 어울리는 스타일을 찾아보자."]
        },
    ],
    "대인관계" : [
        {
            from : "어디에서든 처음보는 사람들과 적응할 수 있는 친화력이 있어야 한다.",
            to : ["처음 보는 사람들과 어디에서든 금방 적응할 수 있어야 한다는 것은 대다수에게 현실적이지 않습니다.", "처음 보는 사람들과 만날 때는 다소 불안하고 불편할 수 있다. 하지만 피하지 않고 부딪혀보겠다."],
        },
        {
            from : "정서적 긴장, 불안이 없어지면 좋을 것 같다.",
            to : ["긴장이나 불안한 감정이 완전히 없어질 수는 없습니다. 오히려 필요한 감정이기도 합니다. 좋은 감정만을 가지려는 감정적 완벽주의는 마음 건강에 좋지 않습니다.", "긴장, 불안을 적절히 조절할 수 있으면 좋겠다."],
        },
        {
            from : "모든 사람들과 원만히 지내고 싶다.",
            to : ["관계는 나 혼자서 결정하는 것이 아니라 상대의 마음도 중요하기 때문에 내가 통제할 수 없으며, 모든 사람들과 잘 지내는 일은 불가능할 수도 있을 만큼 쉬운 일은 아닙니다.", "대부분의 사람들과 원만하게 지내고 싶다."],
        },
        {
            from : "모든 사람들이 나를 좋아했으면 좋겠다.",
            to : ["사람마다 취향, 성향이 다르기 때문에 모든 사람이 나를 좋아할 수는 없습니다. 가까이 하기 힘든 사람이 있는 것처럼요.", "나와 관계된 사람들과 잘 지내도록 배려하고 노력하겠다. 그럼에도 나를 좋아하지 않는 사람은 어쩔 수 없다."],
        },
    ],
    "성공/행복" : [
        {
            from : "남들에게 인정받을 만한 외모, 능력이 있어야 한다.",
            to : ["평가의 주체가 타인이 되는 것은 위험합니다. 자신이 기준이 되지 않기에 늘 기준에 달성하지 못했다는 생각으로 괴로워하게 되기 때문입니다.", "스스로가 만족 할만한 외모나 능력을 설정하고 어떻게 노력해야 할지 계획하자."],
        },
        {
            from : "내가 속한 집단에서는 늘 1등을 하고 싶다.",
            to : ["1등을 하기 위해 열심히 노력하는 것은 긍정적인 부분도 있으나, 결과에 과도하게 매달리면 좌절하거나 실망할 수 있습니다. 늘 1등을 유지하는 것에는 내가 통제할 수 없는 요인들도 관여하기 때문입니다.", "1등이라는 결과를 얻을만한 실력을 가지도록 노력해야 한다."],
        },
        {
            from : "내 분야에 있어서 항상 최고라는 이야기를 들어야 한다.",
            to : ["다른 사람들의 최고라는 평가는 주관적이고 쉽게 변할 수 있습니다. 따라서 내가 아무리 노력한다 하더라도 다른 사람들이 인정해주지 않는다면 물거품이 된 기분이 들 수 있습니다.", "때로는 부정적 감정도 필요하다. 그 감정이 주는 메시지에 귀 기울이고, 받아들이자."],
        },
        {
            from : "행복이란 부정적 감정을 느끼지 않고 언제나 긍정적으로 느껴지는 것이다.",
            to : ["긍정적 감정 뿐만 아니라 부정적 감정도 특정사건에 대해 느끼는 정상적인 감정 반응이며, 부정적 감정 역시 우리가 생존하는데 반드시 필요한 감정입니다. 부정적 감정을 거부하는 감정적 완벽주의는 부정적 사건이 있을 때마다 스스로 이질감을 느끼거나 좌절감을 느낄 수 있습니다.", "때로는 부정적 감정도 필요하다. 그 감정이 주는 메시지에 귀 기울이고, 받아들이자."],
        },
        {
            from : "행복이란 항상 내가 원하는 대로 되는 것이다.",
            to : ["항상 내가 원하는 대로 이루어 지길 원하는 것은 현실적으로 도달하기 힘든 기준입니다. 원하는 대로 되지 않을 때 그만큼 좌절감이 클 수 있습니다. 그리고 나의 노력 여부와 관계없이 얼마든지 외부적 요인으로 인한 변수가 존재할 수 있습니다.", "내가 원하는 대로 되지 않을 수도 있다. 그럴때 어떻게 대처하는지가 중요하고, 그 과정에서 행복을 느낄 수 있다."],
        },
        {
            from : "매일 발전을 해야한다.",
            to : ["기준이 추상적이고 애매모호합니다. 매일 무언가 하고 있음에도 불구하고 아무것도 하지 않고 있다는 느낌이 들 수 있습니다. 때로는 열심히 하지만 후퇴를 하는 것 처럼 느껴질 때도 있지요. 내가 무엇을 중요시 여기는지 범주를 명확히 하고 매일 달성 가능한 기준을 잡는게 필요합니다.", "매일 전공 분야과 관련된 책을 ~페이지 이상 꾸준히 읽도록 하겠다."],
        }
    ]
}

const getChecked = (key) => {
    const range = Standards[key];
    for(const item in range) {
        if(range[item]) return item;
    }
}
const getTo = (type, standard) => {
    const list = Standards[type];
    for(const {from, to} of list) {
        if(from === standard) return {
            advice : to[0],
            changed : to[1],
        }
    }
}

Object.freeze(Standards);

export default Standards;
export { getChecked, getTo };